<template>
  <div>
    <Breadcrumbs main="Beacon" title="Category" />

    <div class="container-fluid">
      <div class="d-flex justify-content-end m-3">
        <b-button variant="primary" class="btn-pill" @click="openModal('Add')">
          <i class="icofont icofont-plus-circle"></i> Add New</b-button>
      </div>
      <ValidationObserver v-slot="{ invalid }">
        <b-modal :hide-footer="modalData.title == 'View'" content-class="rounded-1" v-model="show" body-class="p-4"
          centered :title="`${modalData.title} Category`">
          <div class="row">
            <div class="col-12">
              <ValidationProvider name="Name" rules='required|customRegex|customRegexCRLF|max_length200' v-slot="{ errors }">
                <b-form-group label="Category Name" label-for="name">
                  <template #description>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </template>
                  <b-form-input v-model="name" id="name" :disabled="modalData.disable"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-12">
              <ValidationProvider name="Description" rules='customRegex|max_length200' v-slot="{ errors }">
                <b-form-group label="Description" label-for="description">
                  <template #description>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </template>
                  <b-form-textarea v-model="description" rows="3" :disabled="modalData.disable" id="description">
                  </b-form-textarea>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>
          <template #modal-footer>
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button variant="primary" :disabled="invalid" @click="save(modalData)"><i class="fa fa-save"></i> Save
            </b-button>
          </template>
        </b-modal>
      </ValidationObserver>

      <div class="card p-4">
        <dataTableVue ref="refDataTable" :isSearch="false" :isFilter="true" :isExport="true" v-bind:data="{
                  module: 'beacon',
                  columns: columns,
                  rows: rows,
                  exportDetail: exportDetail,
                  filter_col: [0, 2],
                  filter_custom: 'dynamicFilterVue',
                }" @load="loadItems" @openModal="openModal" @deleteRow="deleteRow" />
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';

export default {
  data() {
    return {
      show: false,
      name: '',
      description: '',
      modalData: {
        title: null,
        disable: false,
        modalData: null,
      },
      columns: [
        {
          label: 'Category Name',
          field: 'name',
          hidden: false,
        },
        {
          label: 'Description',
          field: 'description',
          hidden: false,
        },
        {
          label: 'Update Date',
          field: 'updated_at',
          hidden: false,
        },

        {
          label: 'Action',
          field: 'action',
          thClass: 'custom-th-class',
          hidden: false,
        },
      ],
      rows: [],
      exportDetail: {
        fileName: 'export_category',
        exportUrl: '',
      },
    };
  },
  watch: {
    show(newValue, oldValue) {
      if (oldValue) {
        this.name = '';
        this.description = '';
      }
    },
  },
  mounted() {
    // this.loadColumn();
    setTimeout(() => this.loadItems(), 1000);
  },
  methods: {
    deleteRow(value) {
      const url = `/api/category/${value.row._id}`;
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .DeleteFetch('beacon', url)
              .then(() => {
                this.$swal.fire(
                  'Deleted!',
                  'Your file has been deleted.',
                  'success'
                );
                this.loadItems();
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    save(value) {
      this.show = !this.show;
      // const url = `/api/category`;
      const url = `/api/category${value.title.match('Edit') ? '/' + value.row.row._id : ''
        }`;
      const object = {
        name: this.name,
        description: this.description,
      };
      this.name = '';
      this.description = '';
      requestService
        .PostFetch('beacon', url, object)
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'Category has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          this.loadItems();
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
          });
        });
    },
    openModal(value, id) {
      this.modalData.row = id;
      this.modalData.title = value;
      this.show = !this.show;
      if (!value.match('Add')) {
        this.name = id.row.name;
        this.description = id.row.description;
      }
      value.match('View')
        ? (this.modalData.disable = true)
        : (this.modalData.disable = false);
    },
    async loadItems(event) {
      var str = '';
      if (event != undefined) {
        for (var key in event.params) {
          if (str != '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(event.params[key]);
        }
        this.columns.forEach((element) => {
          if (event.sortField == element.field) {
            if (
              event.sortField == 'created_at' ||
              event.sortField == 'updated_at'
            ) {
              str += '&' + 'sortField=' + event.sortField;
            } else {
              str += '&' + 'sortField=' + element.field;
            }
          }
        });
        if (event.filter != undefined) {
          for (var key in event.filter) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.filter[key]);
          }
        }
      }

      var url = '/api/category/filter?' + str;
      this.exportDetail.exportUrl = '/api/category/export?' + str;
      return requestService
        .GetFetch('beacon', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              self.rows = [];
              const data = text && JSON.parse(text);
              if (data.data.data != null) {
                self.json_data = data.data.data;
                self.rows = data.data.data;
                self.$refs.refDataTable.setTotalRecords(data.data.total);
                self.$refs.refDataTable.setPages(data.data.current_page);
              } else {
                self.$refs.refDataTable.setTotalRecords(0);
                self.$refs.refDataTable.setPages(1);
              }
            });
          }
        })
        .catch((error) => {
          this.$notify({ text: error, type: 'danger' });
        });
    },
  },
};
</script>

<style></style>
